<template>
	<table class="custom-table" :aria-label="ariaLabel">
		<slot />
	</table>
</template>

<script>
export default {
	name: 'Table',
	props: {
		ariaLabel: {
			type: String,
			default: 'table',
		},
	},
};
</script>

<style lang="scss" scoped>
.custom-table {
	width: 100%;
	border: 1px solid $border-color-light;
	border-spacing: 0;
	border-radius: 6px 6px 0 0;
	background-color: $white;

	tr {
		align-items: center;
	}

	thead {
		tr {
			@include rem('padding', 14px 20px);
			background: $header-color-light;
			border-radius: 6px 6px 0 0;

			th {
				text-align: start;
				cursor: pointer;
			}
		}
	}

	tbody {
		tr {
			@include rem('padding', 20px);
			border-top: 1px solid $border-color-light;
		}
	}
}
</style>
